export default __webpack_public_path__ + "static/media/epi-carwash.090db650.jpg";